var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 86,
    viewBox: "0 0 87 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "culture",
    clipPath: "url(#clip0_3818_470)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.9472 45.6093V42.927C77.8534 42.927 80.2263 40.5398 80.2263 37.5894C80.2263 36.1678 79.6664 34.8267 78.6799 33.8342C77.6934 32.815 76.3603 32.2785 74.9472 32.2785H70.8679V29.5963H74.9206C77.0535 29.5963 79.0265 30.4278 80.5463 31.9299C82.0393 33.4319 82.8659 35.4436 82.8925 37.5894C82.8925 42.0151 79.3198 45.6093 74.9472 45.6093Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M67.5884 58.9668V56.2846H78.0399C79.453 56.2846 80.7861 55.7213 81.7726 54.7289C82.7591 53.7096 83.319 52.3954 83.319 50.9738C83.319 49.5522 82.7591 48.2111 81.7726 47.2186C80.7861 46.1994 79.453 45.6629 78.0399 45.6629H68.5216V42.9807H78.0399C80.1729 42.9807 82.1459 43.8122 83.6656 45.3143C85.1587 46.8163 85.9852 48.828 85.9852 50.9738C85.9852 53.1196 85.1587 55.1312 83.6656 56.6333C82.1725 58.1353 80.1729 58.9937 78.0399 58.9937H67.5884V58.9668Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M70.5479 72.2975V69.6152H74.9204C77.8266 69.6152 80.1995 67.2281 80.1995 64.2776C80.1995 62.856 79.6396 61.5149 78.6531 60.5225C77.6666 59.5032 76.3335 58.9668 74.9204 58.9668V56.2845C77.0534 56.2845 79.0264 57.116 80.5461 58.6181C82.0392 60.1201 82.8657 62.1318 82.8924 64.2776C82.8924 68.7033 79.3197 72.2975 74.9471 72.2975H70.5745H70.5479Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M71.5078 85.6282H65.1355V82.946H71.5078C72.9209 82.946 74.254 82.3827 75.2405 81.3903C76.227 80.371 76.7869 79.0567 76.7869 77.6351C76.7869 74.7115 74.414 72.3243 71.4811 72.3243H65.1089V69.6421H71.4811C75.8804 69.6421 79.4531 73.2363 79.4531 77.6351C79.4531 79.7809 78.6266 81.7926 77.1335 83.2947C75.6404 84.7967 73.6408 85.655 71.5078 85.655V85.6282Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.106648 84.5553V81.873L18.2102 81.8462L18.1036 32.654L0 32.6809V29.9986L20.7698 29.9718L20.8764 84.5016L0.106648 84.5553Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M72.0942 85.6013H43.2192C40.473 85.6013 37.7801 84.8503 35.4605 83.4019C33.5409 82.2217 31.3546 81.578 29.0883 81.578H19.5166V78.8958H29.0883C31.8345 78.8958 34.5274 79.6736 36.847 81.0952C38.7666 82.2754 40.9529 82.8923 43.2192 82.8923H72.0942V85.5745V85.6013Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M51.671 44.3218L49.2448 43.1953C51.911 37.4553 53.5374 28.5234 54.0973 16.6948C54.0173 10.6329 52.7109 6.3682 50.3379 4.49063C48.6049 3.12269 46.5253 3.20316 45.1122 3.52503C44.7122 3.6055 44.4456 3.95419 44.4456 4.35652C44.4989 7.49474 44.6322 13.9053 42.8192 18.7333C41.1395 23.2395 38.2867 27.531 34.3673 31.5007C30.9013 35.0145 26.3154 36.9457 21.4096 36.9457H19.5432V34.2634H21.4096C25.5688 34.2634 29.5148 32.6004 32.4743 29.5963C36.127 25.8949 38.7666 21.8983 40.3396 17.7677C41.966 13.4225 41.8594 7.36062 41.8061 4.43699C41.7794 2.69354 42.8992 1.27195 44.5523 0.89644C46.5519 0.44046 49.4581 0.33317 52.0176 2.37167C55.0838 4.8125 56.6835 9.64052 56.7902 16.7216C56.2303 29.1672 54.5505 38.1795 51.6977 44.3218H51.671Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M70.8679 29.5963H53.031V32.2785H70.8679V29.5963Z",
    fill: "#10A2FC",
    stroke: "#10A2FC",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3818_470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.0119,
    height: 85,
    fill: "white",
    transform: "translate(0 0.628174)"
  })))));
};
export default SvgThumbsUp;